import { render, staticRenderFns } from "./menu_edition_entreprise.vue?vue&type=template&id=203d0560"
import script from "./menu_edition_entreprise.js?vue&type=script&lang=js&external"
export * from "./menu_edition_entreprise.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports